import { State, Action } from './kanban.config';

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'TOGGLE_COLLAPSE':
      return {
        ...state,
        collapsed: {
          ...state.collapsed,
          [action.column]: !state.collapsed[action.column],
        },
      };
    default:
      return state;
  }
}
